import React from 'react'
import Container from './container'
import Icon from './icons'
import BlockContent from '@sanity/block-content-to-react'

import styles from './intro.module.css'

function Introduction ({
  twitter,
  linkedIn,
  medium,
  instagram,
  content
}) {

  const socials = [
    twitter && { label: 'Twitter', href: twitter },
    linkedIn && { label: 'LinkedIn', href: linkedIn },
    instagram && { label: 'Instagram', href: instagram },
    medium && { label: 'Substack', href: medium }
  ].filter(Boolean)

  return (
    <Container size='large'>
      <section className={styles.introduction}>
        <BlockContent
          className={styles.bio}
          blocks={content}
        />

        {socials.length > 0 && (
          <div className={styles.introductionSocialRow}>
            {socials.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                target='_blank'
                rel='noreferrer'
                className={styles.introductionSocialLink}
              >
                <p className={styles.introductionSocialLinkText}>
                  {label}
                </p>
                <Icon symbol='arrowTopRight' />
              </a>
            ))}
          </div>
        )}
      </section>
    </Container>
  )
}

export default Introduction
